export const fetchMerchantInfo = (state) => state?.merchant;
